import React, { memo } from 'react'
import { CreateLoadOverlay } from 'apps/fleet-planner/components/modals/CreateLoadOverlay'
import { CreateLoadFormProvider } from 'apps/fleet-planner/context'
import { CreateLoadDefaultValues } from 'apps/fleet-planner/utils/getDefaultLoadState'

interface ICreateLoadContainerProps {
  showModal: boolean
  error?: string
  saving?: boolean
  defaultValues?: CreateLoadDefaultValues
}

export const CreateLoadContainer = memo<ICreateLoadContainerProps>(
  ({ showModal, error, saving, defaultValues = {} }) =>
    showModal ? (
      <CreateLoadFormProvider defaultValues={defaultValues}>
        <CreateLoadOverlay saving={saving} showModal={showModal} error={error} />
      </CreateLoadFormProvider>
    ) : (
      <></>
    )
)
